export default "__VITE_ASSET__BhbsziS$__"